/* globals $, Cookies, RSCP_CFG, RscpCfg, DISPATCH_SERVER_CFG, Controller, Debug, HistoryLogger, RunTimeApi, CommandSentry */

/* exported ReadyThePlayer */
var ReadyThePlayer,
    /* exported rscpCustomizationCompleted */
    rscpCustomizationCompleted,
    rscpCfg,
    IntegrationImplementation,
    Control,
    DebugCommandSentry,
    /* exported HistoryLog */
    HistoryLog;

(function () {
    /* eslint-disable new-cap */
    var getPlayerConfigurationUrl,
        loadCode,
        loadCodeWithScriptTag = false,
        apiNameMap = {
            aicc: "AICC_API",
            scorm11: "API",
            scorm12: "API",
            scorm20042ndedition: "API_1484_11",
            scorm20043rdedition: "API_1484_11",
            scorm20044thedition: "API_1484_11",
            cmi5: "CMI5_API"
        },
        apiReference;

    getPlayerConfigurationUrl = function (query, playerName) {
        var baseUrl,
            urlParams = {},
            match,
            search = /([^&=]+)=?([^&]*)/g,
            result,
            i,
            key;

        while ((match = search.exec(query)) !== null) {
            if (match[1] === "playerConfUrl") {
                baseUrl = decodeURIComponent(match[2]);
            }
            else {
                urlParams[match[1]] = match[2];
            }
        }

        if (typeof baseUrl === "undefined") {
            // TODO: what should this be?
            // eslint-disable-next-line no-alert
            alert("Fatal error occurred: player configuration URL not provided");
            throw new Error("'playerConfUrl' query parameter undefined");
        }

        //
        // force the player name to always be included in the player configuration URL
        // to allow the server side to do things based on what player is provided,
        // primarily specific player customization settings
        //
        // this should be safe with the player query string passed to launch as it will
        // be passed through to the deliver params and should match as it is used by
        // launch to determine which deliver page to load
        //
        urlParams.player = playerName;

        //
        // this assumes that the baseUrl does not have a query string value
        // and/or that values are not trying to be overwritten in it, in theory
        // we could merge parameters, but the existing merge function isn't loaded
        // yet, so rather than move that around stick with the assumption (for now)
        //
        result = baseUrl + "?";

        i = 0;
        for (key in urlParams) {
            if (urlParams.hasOwnProperty(key)) {
                if (i !== 0) {
                    result += "&";
                }
                i += 1;

                // no need to encode URI component, because we didn't decode it above
                result += key + "=" + urlParams[key];
            }
        }

        return result;
    };

    loadCode = function (url, includeScriptDataType) {
        var script,
            deferred,
            ajaxOpts;

        //
        // at the time of development it seems Chrome's use of source maps
        // breaks when using the .ajax XHR based script loading capability
        // which we are using for proper error handling of loaded files, but
        // for debugging purposes it is better to have source maps, so if
        // source maps are needed in Chrome set this flag to true, just realize
        // that then error handling will not happen even on errors
        //
        if (loadCodeWithScriptTag) {
            deferred = $.Deferred();

            // not using jquery here for create element and appending because
            // it will take over and try to do for us what our .ajax method does
            script = document.createElement("script");
            script.async = true;
            script.src = url;
            script.onload = function () {
                if (! script.readyState || /loaded|complete/.test(script.readyState)) {
                    script.parentNode.removeChild(script);
                    script = null;

                    deferred.resolve();
                }
            };

            document.getElementsByTagName("head")[0].appendChild(script);

            return deferred;
        }

        ajaxOpts = {
            url: url,
            cache: true,
            xhrFields: {
                withCredentials: true
            }
        };

        if (typeof includeScriptDataType === "undefined" || includeScriptDataType) {
            ajaxOpts.dataType = "script";
        }
        else {
            ajaxOpts.dataType = "text";
        }

        return $.ajax(ajaxOpts);
    };

    //
    // using this function wrap what essentially could be done with simple loading
    // because in a frameset only document (like legacy player) the code in the script
    // wasn't being executed when loaded
    //
    ReadyThePlayer = function (playerName, cacheBuster) {
        var getQueryStringParam = function (win, paramName) {
                var qs = win.location.search.toString(),
                    paramStart = qs.indexOf(paramName + "="),
                    paramValue;

                if (paramStart === -1) {
                    return null;
                }

                paramValue = qs.substring(paramStart + paramName.length + 1, qs.length);
                if (paramValue.indexOf("&") > -1) {
                    paramValue = paramValue.substring(0, paramValue.indexOf("&"));
                }

                return decodeURIComponent(paramValue.replace(/\+/g, " "));
            },
            qsNonce = getQueryStringParam(window, "nonce"),
            deliverRefreshNonceCookieName = "deliverNonce",
            deliverRefreshUrlCookieName = "deliverRefreshUrl",
            cookieNonce,
            refreshRedirectUrl,
            playerConfigurationUrl,
            loadCodeMethodParam;

        //
        // check for a `nonce` query string parameter, when present that indicates that there is a refresh
        // redirect URL in place, so then check the `deliverNonce` cookie, in the case they match then need
        // to redirect to the URL, if the cookie isn't found or doesn't match, then set the cookie to the
        // value from the query string and then load regularly, the URL will be set once the configuration
        // has loaded and will persist in case of refresh
        //
        if (qsNonce !== null && qsNonce !== "") {
            cookieNonce = Cookies.get(deliverRefreshNonceCookieName);
            if (cookieNonce === qsNonce) {
                refreshRedirectUrl = Cookies.get(deliverRefreshUrlCookieName);

                if (typeof refreshRedirectUrl !== "undefined") {
                    document.location.href = refreshRedirectUrl;

                    return;
                }
            }

            Cookies.set(deliverRefreshNonceCookieName, qsNonce, {expires: 365});
        }

        // getting this here so that we can fail early in case the parameter isn't present
        playerConfigurationUrl = getPlayerConfigurationUrl(window.location.search.substring(1), playerName);

        loadCodeMethodParam = getQueryStringParam(window, "loadCodeMethod");
        if (loadCodeMethodParam !== null && loadCodeMethodParam === "tag") {
            loadCodeWithScriptTag = true;
        }

        loadCode(playerConfigurationUrl, false).then(
            // eslint-disable-next-line complexity
            function (data) {
                var resourceUrl = "js/resources/AppStrings",
                    topParams,
                    reg,
                    clientCustomizationStylesheet,
                    contentAuthCookies,
                    i,
                    cookie,
                    cookieCfg;

                if (! loadCodeWithScriptTag) {
                    $.globalEval(data);
                }

                rscpCfg = new RscpCfg(RSCP_CFG);
                topParams = rscpCfg.get("topParams");
                reg = rscpCfg.get("registrationToDeliver");
                clientCustomizationStylesheet = rscpCfg.get("clientCustomizationStylesheet");
                contentAuthCookies = rscpCfg.get("contentAuthCookies");

                if (rscpCfg.get("learningStandard").indexOf("scorm2004") !== -1 && ! rscpCfg.get("is2004Enabled")) {
                    return $.Deferred().reject(new Error("This course requires SCORM 2004 which is not supported in this version of the SCORM Content Player. You will need to upgrade your player to run this content."));
                }

                if (topParams.cc === "") {
                    topParams.cc = "en-US";
                }
                if (topParams.cc !== "en-US") {
                    resourceUrl += "." + topParams.cc.toLowerCase();
                }
                resourceUrl += ".js?cache=" + cacheBuster;

                $("html").prop("lang", topParams.cc);
                if (rscpCfg.get("langDirection") !== null) {
                    $("html").prop("dir", rscpCfg.get("langDirection"));
                }

                if (rscpCfg.get("redirectOnRefreshUrl") !== null && rscpCfg.get("redirectOnRefreshUrl") !== "") {
                    Cookies.set(deliverRefreshUrlCookieName, rscpCfg.get("redirectOnRefreshUrl"), {expires: 365});
                }

                if (contentAuthCookies !== null && contentAuthCookies.length > 0) {
                    for (i = 0; i < contentAuthCookies.length; i += 1) {
                        cookie = contentAuthCookies[i];

                        // If this is loaded over http, then we don't want to keep
                        // the secure/sameSite value because they would prevent the
                        // cookie from being used.
                        if (document.location.protocol === "http:") {
                            cookie.secure = false;

                            if (cookie.sameSite === "None") {
                                cookie.sameSite = "Unspecified";
                            }
                        }

                        cookieCfg = {
                            secure: cookie.secure,
                            path: cookie.path
                        };

                        if (cookie.sameSite !== "Unspecified") {
                            cookieCfg.sameSite = cookie.sameSite;
                        }

                        Cookies.set(cookie.name, cookie.value, cookieCfg);
                    }
                }

                if (rscpCfg.get("isOffline") !== null && rscpCfg.get("isOffline")) {
                    // setting these to true because these are set to false by default since this originated as a preview launch
                    HistoryLog = new HistoryLogger(
                        true,
                        true,
                        "mobile-launch"
                    );
                }
                else {
                    HistoryLog = new HistoryLogger(
                        reg.TrackingEnabled && reg.Package.Properties.CaptureHistory,
                        reg.TrackingEnabled && reg.Package.Properties.CaptureHistoryDetailed,
                        rscpCfg.get("version")
                    );
                }

                if (rscpCfg.get("resizeToWidth") !== null && rscpCfg.get("resizeToHeight") !== null) {
                    window.resizeTo(rscpCfg.get("resizeToWidth"), rscpCfg.get("resizeToHeight"));
                }
                if (rscpCfg.get("moveToLeft") !== null && rscpCfg.get("moveToTop") !== null) {
                    window.moveTo(rscpCfg.get("moveToLeft"), rscpCfg.get("moveToTop"));
                }

                // Add origin trial meta tags within the head element if we've received any
                // in the player configuration
                for (i = 0; i < rscpCfg.get("originTrialTokens").length; i += 1) {
                    $("head").append("<meta http-equiv=\"origin-trial\" content=\"" + rscpCfg.get("originTrialTokens")[i] + "\">");
                }

                //
                // check for and load client's CSS file if exists, no need to wait for it to finish
                // and less concern for errors as it hopefully means things just don't look right
                // as opposed to broken functionality
                //
                if (clientCustomizationStylesheet !== null && clientCustomizationStylesheet !== "") {
                    // eslint-disable-next-line object-property-newline
                    $("<link>", {
                        rel: "stylesheet",
                        href: clientCustomizationStylesheet
                    }).appendTo("head");
                }

                return loadCode(resourceUrl).then(
                    null,
                    function (jqXHR, textStatus, errorThrown) {
                        return new Error("Failed to load resource file: '" + resourceUrl + "', reason: " + errorThrown + ", status: " + jqXHR.status);
                    }
                );
            },
            function (jqXHR, textStatus, errorThrown) {
                // If we failed because of an expired launch link token, send a better message
                if (jqXHR.status === 400 && jqXHR.responseText && jqXHR.responseText.indexOf("Token has expired") !== -1) {
                    return new Error("Your launch token has expired. Please relaunch this course.");
                }

                return new Error("Failed to load player configuration url: '" + playerConfigurationUrl + "', reason: " + errorThrown + ", status: " + jqXHR.status);
            }
        ).then(
            function () {
                if (typeof IntegrationImplementation.PostResourceStringsLoaded !== "undefined") {
                    IntegrationImplementation.PostResourceStringsLoaded();
                }

                return loadCode("js/" + rscpCfg.get("learningStandard") + "-min.js?cache=" + cacheBuster).then(
                    null,
                    function () {
                        return new Error("Failed to load learning standard file:" + rscpCfg.get("learningStandard"));
                    }
                );
            }
        ).then(
            function () {
                var sspEnabled = rscpCfg.get("sspEnabled");

                if (sspEnabled !== null && sspEnabled) {
                    return loadCode("js/ssp-min.js?cache=" + cacheBuster).then(
                        null,
                        function () {
                            return new Error("Failed to load SSP file");
                        }
                    );
                }
            }
        ).then(
            function () {
                // eslint-disable-next-line newline-per-chained-call
                if (window.location.toString().toLowerCase().indexOf("preventrightclick=true") > 0) {
                    window.document.oncontextmenu = function () {
                        return false;
                    };
                }

                // always need a CommandSentry to exist, but only enable the keyboard
                // triggers when the debugger is enabled
                DebugCommandSentry = new CommandSentry();
                if (rscpCfg.get("clientDebuggerEnabled")) {
                    DebugCommandSentry.addCommand(
                        function () {
                            Debug.ShowAllAvailableData();
                        },
                        [63, 63, 63, 63, 63],
                        ["l", "d", "r", "d", "l"]
                    );
                    DebugCommandSentry.addCommand(
                        function () {
                            Debug.ShowDebugLogAtExit = true;
                        },
                        [63, 63, 63, 63, 68],
                        ["d", "r", "d", "t"]
                    );
                }

                apiReference = new RunTimeApi(rscpCfg.get("learnerId"), rscpCfg.get("learnerName"));
                apiReference.playerName = "scormengine";
                apiReference.playerVersion = rscpCfg.get("version");

                window[apiNameMap[rscpCfg.get("learningStandard")]] = apiReference;

                if (typeof IntegrationImplementation.PostRunTimeCreation !== "undefined") {
                    IntegrationImplementation.PostRunTimeCreation();
                }

                if (rscpCfg.get("headerAdditions") !== null) {
                    $.globalEval(rscpCfg.get("headerAdditions"));
                }
            }
        ).then(
            function () {
                if (typeof DISPATCH_SERVER_CFG !== "undefined") {
                    return loadCode("js/dispatch-server-min.js?cache=" + cacheBuster).then(
                        null,
                        function (jqXHR, textStatus, errorThrown) {
                            return new Error("Failed to load dispatch server code, reason: " + errorThrown + ", status: " + jqXHR.status);
                        }
                    );
                }
            }
        ).then(
            function () {
                var isOffline = rscpCfg.get("isOffline");

                if (isOffline !== null && isOffline) {
                    return loadCode("js/offline-min.js?cache=" + cacheBuster).then(
                        null,
                        function () {
                            return new Error("Failed to load offline file");
                        }
                    );
                }
            }
        ).then(
            function () {
                var clientCustomizationScript = rscpCfg.get("clientCustomizationScript"),
                    clientCustomizationTimeout,
                    deferred;

                if (clientCustomizationScript !== null && clientCustomizationScript !== "") {
                    deferred = $.Deferred();

                    rscpCustomizationCompleted = function (err) {
                        window.clearTimeout(clientCustomizationTimeout);

                        if (typeof err !== "undefined" && err !== null) {
                            deferred.reject(new Error("Failed client customization script with error: " + err));

                            return;
                        }

                        deferred.resolve();
                    };

                    // set up a timeout to provide a way to debug that they didn't call our function
                    clientCustomizationTimeout = window.setTimeout(
                        function () {
                            /* eslint-disable no-console */
                            if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
                                console.warn("Player customization script detected but `rscpCustomizationCompleted()` not called");
                            }
                            /* eslint-enable no-console */
                        },
                        5000
                    );

                    loadCode(clientCustomizationScript).then(
                        function () {
                            // up to client to call `rscpCustomizationCompleted` to resolve the promise
                        },
                        function (jqXHR, textStatus, errorThrown) {
                            deferred.reject(new Error("Failed to load client customization script:" + clientCustomizationScript + ", reason: " + errorThrown + ", status: " + jqXHR.status));
                        }
                    );

                    return deferred;
                }
            }
        ).then(
            function () {
                var createControl,
                    deferredControl = $.Deferred();

                createControl = function () {
                    //
                    // this try/catch has been in the code for a long time (originally in the
                    // server side generated version) and probably has to do with the timing
                    // of loading of things, but at this point it is for sure needed as it is
                    // possible that the controller will fail during initialization because
                    // the menu root element isn't in the DOM yet because it is still being
                    // loaded in a frame, but creating the controller is otherwise synchronous
                    // so we just have to let it fail and then try again after hopefully
                    // whatever was missing has loaded
                    //
                    try {
                        Control = new Controller();

                        window.onbeforeunload = function () {
                            return Control.BeforeUnload();
                        };
                        window.onunload = function () {
                            Control.Unload();
                        };
                        window.onpagehide = function () {
                            Control.Unload();
                        };
                        deferredControl.resolve();

                        return deferredControl.promise();
                    }
                    catch (err) {
                        setTimeout(createControl, 1000);

                        return deferredControl.promise();
                    }
                };

                $.when(createControl()).done(
                    function () {
                        Control.Initialize(apiReference);
                    }
                );
            }
        ).then(
            null,
            function (error) {
                var node,
                    content = [
                        "<h3>Error occurred!</h3>",
                        "<h4>Failed to load player dependencies</h4>",
                        "<p>" + $("<p>").text(error).html() + "</p>"
                    ];

                if (playerName === "modern") {
                    // use body for modern to maintain basic CSS
                    node = $("body");
                }
                else if (playerName === "legacy") {
                    // use html for legacy to avoid mucking with the frames
                    node = $("html");
                }

                if (typeof RSCP_CFG !== "undefined" && typeof RSCP_CFG.redirectOnExitUrl !== "undefined") {
                    content.push(
                        "<a href=\"" + RSCP_CFG.redirectOnExitUrl + "\">Return to LMS</a>"
                    );
                }

                node.html(content.join("\n"));
            }
        );
    };
}());
